import httpClient from 'api/httpClient';
import { UserEnquiryContext } from 'models/UserEnquiryContext';

function getEnquiryContexts() {
  return httpClient.get<Array<UserEnquiryContext>>('enquiry-contexts');
}

function getEnquiryContext(contextId: string) {
  return httpClient.get<UserEnquiryContext>(`enquiry-contexts/${contextId}`);
}

function createEnquiryContext(tag: string, description: string) {
  return httpClient.post<UserEnquiryContext>('enquiry-contexts', {
    tag,
    description,
  });
}

function updateEnquiryContext(
  contextId: string,
  tag: string,
  description: string,
) {
  return httpClient.patch<UserEnquiryContext>(`enquiry-contexts/${contextId}`, {
    tag,
    description,
  });
}

function deleteEnquiryContext(contextId: string) {
  return httpClient.delete(`enquiry-contexts/${contextId}`);
}

export default {
  getEnquiryContexts,
  getEnquiryContext,
  createEnquiryContext,
  updateEnquiryContext,
  deleteEnquiryContext,
};
